import regression from "regression";

export function computeLinearRegression(xDates, yValues) {
  const timestamps = xDates.map((d) => new Date(d).getTime());
  const data = timestamps.map((t, i) => [t, yValues[i]]);
  const result = regression.linear(data);

  return {
    slope: result.equation[0],
    intercept: result.equation[1],
    r2: result.r2,
    trendData: xDates.map((d) => {
      const t = new Date(d).getTime();
      return result.predict(t)[1];
    }),
  };
}

export function computePolynomialRegression(xValues, yValues, order = 2) {
  const timestamps = xValues.map((d) => new Date(d).getTime());
  const min = Math.min(...timestamps);
  const max = Math.max(...timestamps);
  const range = max - min || 1;

  const normalizedX = timestamps.map((t) => (t - min) / range);
  const data = normalizedX.map((x, i) => [x, yValues[i]]);

  const result = regression.polynomial(data, { order });

  const trendData = normalizedX.map((x) => result.predict(x)[1]);

  return {
    equation: result.string
      .replace(/\^2/g, "²")
      .replace(/\^3/g, "³")
      .replace(/\^4/g, "⁴"),
    r2: result.r2,
    trendData,
  };

}



